import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TemporaryAccessApiService } from 'app/services/temporary-access-api.service';
import { TempAccessSessionService } from 'app/services/temp-access-session.service';

@Component({
  selector: 'planograms-access-loader',
  template: `
    <div
      style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:60vh;padding:24px;text-align:center;"
    >
      <div style="font-size:16px;margin-bottom:8px;">Validando acceso…</div>
      <div style="opacity:.7;font-size:13px;">Un momento por favor.</div>
    </div>
  `,
})
export class PlanogramsAccessLoaderComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tempAccessApi: TemporaryAccessApiService,
    private tempAccessSession: TempAccessSessionService
  ) {}

  ngOnInit(): void {
    // CATMAN-B020 — Aislamiento real per-tab (sin romper la sesión normal de otras pestañas).
    // Marcamos esta pestaña como temporal (sessionStorage = per-tab) ANTES de cualquier
    // request. El interceptor lee esta marca y nunca usa OIDC ni el token normal en esta
    // pestaña. NO se limpia el localStorage/cookies compartidos: hacerlo destruía la sesión
    // normal abierta en otra pestaña del mismo navegador (causa raíz del bug reportado).
    this.tempAccessSession.markTabAsTemporary();

    const code = this.route.snapshot.paramMap.get('code');
    if (!code) {
      this.router.navigate(['/unauthorized']);
      return;
    }

    this.tempAccessApi.exchangeCode(code).subscribe({
      next: res => {
        if (!res?.access_token) {
          this.tempAccessSession.clearSession();
          this.router.navigate(['/unauthorized']);
          return;
        }

        this.tempAccessSession.setSession(res.access_token, res.expires_in);
        this.router.navigateByUrl('/spaces/planograms/guest-list', { replaceUrl: true });
      },
      error: () => {
        this.tempAccessSession.clearSession();
        this.router.navigate(['/unauthorized']);
      },
    });
  }
}
